<template>
  <div class="repore">
    <div class="repore-background">
      <div class="cardnber-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        欧堡利亚医院
      </div>
      <div class="repore-irmaon">
        <div class="verion-irmaon-camber verion-irmaon-soline">
          <span>报告人姓名</span>
          <input type="text" v-model="rertme" placeholder="请输入报告所属人姓名" @input="reptne()">
        </div>
        <div class="verion-irmaon-camber verion-irmaon-soline">
          <span>报告身份证</span>
          <input type="text" v-model="reorcd" placeholder="请输入报告所属人身份证" @input="rertad()">
        </div>
        <div class="verion-irmaon-soline verion-irmaon-vecade">
          <span>报告人手机</span>
          <input type="Number" v-model="remonr" placeholder="请输入手机号" @input="reoubr()">
          <button :disabled="repodisa" @click="recade()">{{this.recoxt}}</button>
        </div>
        <div class="verion-irmaon-camber">
          <span>短信验证码</span>
          <input type="Number" v-model="revand" placeholder="请输入短信验证码" @input="revacd()">
        </div>
      </div>
      <button class="verion-crsion" @click="recosu()">确定</button>
    </div>
    <!-- 错误提示 -->
    <Errosage :style="'display:' + rerierge" :txtrro="this.reersg"></Errosage>
    <!-- 成功提示 -->
    <Succtips :style="'display:' + rerisups"></Succtips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      rertme: '',
      reorcd: '',
      remonr: '',
      revand: '',
      rerierge: 'none',
      rerisups: 'none',
      reersg: '',
      recoxt: '获取验证码',
      repodisa: false,
    }
  },
  created () {
    
  },
  mounted () {

  },
  methods: {
    // 倒计时
    recown(){
      this.repodisa = true;
      const _this = this;
      var retime = 60;
      this.recoxt = retime + 's';
      let retung = setInterval(function() {
        retime--;
        _this.recoxt = retime + 's';
        if(retime < 0) {
          _this.recoxt = "重新发送";
          retime = 60;
          _this.repodisa = false;
          clearInterval(retung);
        }
      }, 1000);
    },
    // 获取用户的姓名
    reptne(){
      console.log(this.rertme);
    },
    // 获取用户的身份证号码
    rertad(){
      console.log(this.reorcd);
    },
    // 获取用户手机号
    reoubr(){
      console.log(this.remonr);
    },
    // 获取短信验证码
    revacd(){
      console.log(this.revand);
    },
    // 点击获取验证码触发
    recade(){
      if(this.remonr == ''){
        this.reersg = '手机号不能为空';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(!(/^1[3456789]\d{9}$/.test(this.remonr))){
        this.reersg = '手机号格式错误';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else{
        this.$axios.post('wx/sendCode',this.$qs.stringify({
          USERNAME: this.remonr
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.state == '0'){
            this.recown();
          }else{
            this.reersg = res.data.Msg;
            this.rerierge = 'block';
            const _this = this;
            setTimeout(function(){
              _this.rerierge = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 点击确认触发
    recosu(){
      if(this.rertme == ''){
        this.reersg = '姓名不能为空';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(this.reorcd == ''){
        this.reersg = '身份证号不能为空';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(!(/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.reorcd))){
        this.reersg = '身份证号格式错误';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(this.remonr == ''){
        this.reersg = '手机号不能为空';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(!(/^1[3456789]\d{9}$/.test(this.remonr))){
        this.reersg = '手机号格式错误';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else if(this.revand == ''){
        this.reersg = '验证码不能为空';
        this.rerierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.rerierge = 'none';
        },1200)
      }else{
        this.$axios.post('wx/codecheck',this.$qs.stringify({
          USERNAME: this.remonr,
          CODE: this.revand
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.state == '0'){
            this.$axios.post('https://wd.obraopay.com/zsk/wx/checkUserBoolean',this.$qs.stringify({
              USERNAME: this.remonr,
              IDNUMBER: this.reorcd,
              NAME: this.rertme
            }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
            .then(res => {
              if(res.data.flag == '0'){
                this.rerisups = 'block';
                const _this = this;
                setTimeout(function(){
                  _this.rerisups = 'none';
                  _this.$router.push({name: 'medirt',query: {recots: _this.remonr,reinty: _this.reorcd,reonac: _this.rertme}});
                },1200)
              }else{
                this.reersg = '用户信息错误,请输入预约时所填写的信息!';
                this.rerierge = 'block';
                const _this = this;
                setTimeout(function(){
                  _this.rerierge = 'none';
                },1200)
              }
            })
            .catch(() => {
              console.log('获取失败');
            });
          }else{
            this.reersg = res.data.Msg;
            this.rerierge = 'block';
            const _this = this;
            setTimeout(function(){
              _this.rerierge = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/repore.css";
</style>